/**
 * Company: SPHMedia
 * Description: [myBH Layout 2 component]
 */

import { ProcessedArticleData } from "@hooks/transformer/useOSResponse";
import WidgetWrapper from "@routes/Home/HomePageLayout/WidgetWrapper";
import { ReactElement } from "react";

import { LAYOUT_TWO_ARRANGEMENT } from "./helper/layout";
import { renderSlot } from "./helper/renderSlot";

export type MyBHLayoutTwoProps = {
  articles: ProcessedArticleData[];
};

/**
 * MyBHLayoutTwo
 * Description: [Layout 2 component for myBH "For You" page]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function MyBHLayoutTwo({
  articles,
}: MyBHLayoutTwoProps): ReactElement {
  if (articles.length === 0) {
    return <div>No articles available.</div>;
  }

  return (
    <WidgetWrapper>
      {/* Desktop and Tablet */}
      <div
        className="hidden md:block max-w-[1183px]"
        data-testid="desktop-tablet-layout"
      >
        <div
          key="desktop-tab-layout"
          className="grid md:grid-cols-2 lg:grid-cols-3 gap-5"
        >
          {LAYOUT_TWO_ARRANGEMENT.map((slot) =>
            renderSlot(
              {
                imgWidth: 381,
                imgHeight: 261.6,
                ...slot,
              },
              articles,
              "layoutTwoDesktopTab",
            ),
          )}
        </div>
      </div>

      {/* Mobile */}
      <div className="flex md:hidden" data-testid="mobile-layout">
        <div key="mobile-layout" className="flex flex-col gap-7">
          {articles
            .slice(0, 6)
            .map((_, i) =>
              renderSlot({ index: i }, articles, "layoutTwoMobile"),
            )}
        </div>
      </div>
    </WidgetWrapper>
  );
}
